<template>
  <label class="lp-radio">
    <input
      type="radio"
      v-bind="$attrs"
      :value="nativeValue"
      :checked="value === nativeValue"
      @change="$emit('input', nativeValue)"
    />
    <span class="lp-radio__label">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'lp-radio',
  inheritAttrs: false,
  props: {
    // Currently-selected value of the group (v-model).
    value: { type: [String, Number, Boolean, null], default: null },
    // This radio's own value.
    nativeValue: { type: [String, Number, Boolean], default: null },
    label: { type: String, default: '' },
  },
}
</script>
